"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__resetKevelVisibilityState__ = exports.unobserveKevelBanner = exports.observeKevelBanner = void 0;
const dispatchAnalytics_1 = require("./dispatchAnalytics");
const firedImpressions = new Set();
const pendingImpressions = new Map();
let sharedObserver = null;
let ensReadyListenerAttached = false;
const getImpressionKey = (eventData) => `${eventData.adId}`;
const dispatchVisibleImpression = (eventData) => {
    const key = getImpressionKey(eventData);
    if (firedImpressions.has(key)) {
        console.log("[Kevel] Impression already fired for", key);
        return;
    }
    console.log("[Kevel] Dispatching impression for", key);
    (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)(Object.assign({ action: "kevel.impression" }, eventData));
    firedImpressions.add(key);
};
const flushPendingImpressions = () => {
    console.log("[Kevel] flushPendingImpressions called, pending count:", pendingImpressions.size);
    const events = Array.from(pendingImpressions.values());
    pendingImpressions.clear();
    events.forEach(({ eventData }) => {
        console.log("[Kevel] Flushing pending impression for", eventData.adId);
        dispatchVisibleImpression(eventData);
    });
};
const ensureEnsReadyListener = () => {
    if (ensReadyListenerAttached || !document.body) {
        console.log("[Kevel] ENS listener already attached or no document.body");
        return;
    }
    console.log("[Kevel] Attaching ensEventsReady listener");
    document.body.addEventListener("ensEventsReady", flushPendingImpressions, {
        once: true,
    });
    ensReadyListenerAttached = true;
};
const ensureObserver = () => {
    ensureEnsReadyListener();
    if (sharedObserver &&
        sharedObserver.constructor !== window.IntersectionObserver) {
        console.log("[Kevel] Constructor mismatch, disconnecting and recreating observer");
        sharedObserver.disconnect();
        sharedObserver = null;
    }
    if (sharedObserver || !window.IntersectionObserver) {
        console.log("[Kevel] Returning existing observer or null");
        return sharedObserver;
    }
    console.log("[Kevel] Creating new IntersectionObserver");
    sharedObserver = new window.IntersectionObserver((entries) => {
        console.log("[Kevel Observer] Callback fired with", entries.length, "entries");
        entries.forEach((entry) => {
            var _a, _b;
            const target = entry.target;
            const eventData = target.__kevelEventData;
            console.log("[Kevel Observer] Processing entry:", {
                isIntersecting: entry.isIntersecting,
                intersectionRatio: entry.intersectionRatio,
                hasEventData: !!eventData,
                adId: eventData === null || eventData === void 0 ? void 0 : eventData.adId,
                ensEventsReady: (_a = window.Bootstrapper) === null || _a === void 0 ? void 0 : _a.ensEventsReady,
            });
            if (!eventData) {
                console.log("[Kevel Observer] No event data on element, skipping");
                return;
            }
            const key = getImpressionKey(eventData);
            if (!entry.isIntersecting || entry.intersectionRatio <= 0) {
                console.log("[Kevel] Not in view, removing from pending", key);
                pendingImpressions.delete(key);
                return;
            }
            if ((_b = window.Bootstrapper) === null || _b === void 0 ? void 0 : _b.ensEventsReady) {
                console.log("[Kevel] ENS ready, dispatching immediately", key);
                dispatchVisibleImpression(eventData);
                sharedObserver === null || sharedObserver === void 0 ? void 0 : sharedObserver.unobserve(target);
                return;
            }
            console.log("[Kevel] ENS not ready, queueing", key, "pending count:", pendingImpressions.size + 1);
            pendingImpressions.set(key, { element: target, eventData });
        });
    });
    return sharedObserver;
};
const observeKevelBanner = (element, eventData) => {
    var _a;
    if (!element) {
        console.log("[Kevel] observeKevelBanner called with null element");
        return;
    }
    const target = element;
    const key = getImpressionKey(eventData);
    console.log("[Kevel] observeKevelBanner for", key);
    if (firedImpressions.has(key)) {
        console.log("[Kevel] Already fired, skipping", key);
        return;
    }
    target.__kevelEventData = eventData;
    const observer = ensureObserver();
    if (!observer) {
        console.log("[Kevel] No observer available");
        if ((_a = window.Bootstrapper) === null || _a === void 0 ? void 0 : _a.ensEventsReady) {
            dispatchVisibleImpression(eventData);
        }
        return;
    }
    console.log("[Kevel] Attaching observer to element", key);
    observer.observe(element);
};
exports.observeKevelBanner = observeKevelBanner;
const unobserveKevelBanner = (element, eventData) => {
    if (!element) {
        return;
    }
    const target = element;
    if (eventData) {
        pendingImpressions.delete(getImpressionKey(eventData));
    }
    delete target.__kevelEventData;
    sharedObserver === null || sharedObserver === void 0 ? void 0 : sharedObserver.unobserve(element);
};
exports.unobserveKevelBanner = unobserveKevelBanner;
// For testing purposes only - resets module state
const __resetKevelVisibilityState__ = () => {
    firedImpressions.clear();
    pendingImpressions.clear();
    if (sharedObserver) {
        sharedObserver.disconnect();
    }
    sharedObserver = null;
    ensReadyListenerAttached = false;
};
exports.__resetKevelVisibilityState__ = __resetKevelVisibilityState__;
